"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledChartTooltipValueItem = exports.StyledChartTooltipValues = exports.StyledChartTooltipTitle = void 0;
const styled_components_1 = __importStar(require("styled-components"));
exports.StyledChartTooltipTitle = styled_components_1.default.h4 `
  font-weigth: 600;
`;
exports.StyledChartTooltipValues = styled_components_1.default.ul `
  list-style: none;
  padding: 0;
`;
exports.StyledChartTooltipValueItem = styled_components_1.default.li.withConfig({
    shouldForwardProp: (prop) => !["color"].includes(prop),
}) `
  ${({ color }) => {
    return (0, styled_components_1.css) `
      color: ${color};
    `;
}}
  & > i {
    margin-right: 0.5rem;
  }
`;
//# sourceMappingURL=styled.js.map